const Loader = ({ message = "Loading..." }) => {
  return (
    <div className="fixed inset-0 bg-gray-900/50 backdrop-blur-sm z-50 flex items-center justify-center">
      <div className="bg-white rounded-3xl p-8 shadow-2xl max-w-sm mx-4">
        <div className="flex flex-col items-center">
          {/* Animated Rocket */}
          <div className="relative mb-6">
            {/* Rocket SVG with Animation */}
            <div className="animate-bounce-slow">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="none" className="w-24 h-24">
                {/* Rocket Body */}
                <path d="M50 10 L60 40 L60 70 L50 80 L40 70 L40 40 Z" fill="url(#gradient1)"/>
                
                {/* Rocket Window */}
                <circle cx="50" cy="35" r="8" fill="#e0e7ff"/>
                <circle cx="50" cy="35" r="6" fill="#818cf8"/>
                
                {/* Rocket Fins */}
                <path d="M40 50 L30 65 L40 60 Z" fill="#4f46e5"/>
                <path d="M60 50 L70 65 L60 60 Z" fill="#4f46e5"/>
                
                {/* Rocket Nose */}
                <path d="M50 10 L45 20 L55 20 Z" fill="#818cf8"/>
                
                {/* Animated Flame */}
                <g className="animate-pulse">
                  <ellipse cx="50" cy="82" rx="8" ry="12" fill="#f59e0b"/>
                  <ellipse cx="50" cy="85" rx="6" ry="8" fill="#fbbf24"/>
                  <ellipse cx="50" cy="87" rx="4" ry="5" fill="#fef3c7"/>
                </g>
                
                {/* Gradient Definition */}
                <defs>
                  <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style={{stopColor: '#6366f1', stopOpacity: 1}} />
                    <stop offset="100%" style={{stopColor: '#8b5cf6', stopOpacity: 1}} />
                  </linearGradient>
                </defs>
              </svg>
            </div>

            {/* Orbiting Stars */}
            <div className="absolute inset-0 animate-spin-slow">
              <div className="absolute top-0 left-1/2 w-2 h-2 bg-yellow-400 rounded-full -ml-1"></div>
              <div className="absolute bottom-0 left-1/2 w-2 h-2 bg-yellow-400 rounded-full -ml-1"></div>
              <div className="absolute left-0 top-1/2 w-2 h-2 bg-yellow-400 rounded-full -mt-1"></div>
              <div className="absolute right-0 top-1/2 w-2 h-2 bg-yellow-400 rounded-full -mt-1"></div>
            </div>
          </div>

          {/* Loading Text */}
          <h3 className="text-xl font-bold text-gray-900 mb-2">
            {message}
          </h3>

          {/* Loading Dots */}
          <div className="flex space-x-2">
            <div className="w-2 h-2 bg-indigo-600 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-2 h-2 bg-purple-600 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-2 h-2 bg-pink-600 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes bounce-slow {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-20px);
          }
        }
        @keyframes spin-slow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
        .animate-bounce-slow {
          animation: bounce-slow 2s ease-in-out infinite;
        }
        .animate-spin-slow {
          animation: spin-slow 8s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default Loader;
